var $7ea012e91a5ad3ee$exports = {};
$7ea012e91a5ad3ee$exports = {
  "alpha": "Alfa",
  "black": "must",
  "blue": "Sinine",
  "blue purple": "sinakaslilla",
  "brightness": "Heledus",
  "brown": "pruun",
  "brown yellow": "pruunikaskollane",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "ts\xFCaan",
  "cyan blue": "ts\xFCaansinine",
  "dark": "tume",
  "gray": "hall",
  "grayish": "hallikas",
  "green": "Roheline",
  "green cyan": "ts\xFCaanroheline",
  "hue": "V\xE4rv",
  "light": "valgus",
  "lightness": "Valgus",
  "magenta": "magentapunane",
  "magenta pink": "magentaroosa",
  "orange": "oran\u017E",
  "orange yellow": "oran\u017Eikaskollane",
  "pale": "kahvatu",
  "pink": "roosa",
  "pink red": "vaarikapunane",
  "purple": "lilla",
  "purple magenta": "purpurne magenta",
  "red": "Punane",
  "red orange": "punakasoran\u017E",
  "saturation": "K\xFCllastus",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " l\xE4bipaistev");
  },
  "very dark": "v\xE4ga tume",
  "very light": "v\xE4ga hele",
  "vibrant": "ere",
  "white": "valge",
  "yellow": "kollane",
  "yellow green": "kollakasroheline"
};
export { $7ea012e91a5ad3ee$exports as default };